module.exports = __webpack_public_path__ + "static/media/aave.cd5872f6.svg";